import React, { useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import useClickOutside from "../../hooks/useClickOutside";
import { logout } from "../../utils/ApiUtils";
import { dashEndLinks, dashMidLinks } from "./constants";
import { HiMenu } from "react-icons/hi";
import { RiCloseFill } from "react-icons/ri";

const DashboardNavbar = ({ registryPreview }) => {
  const history = useHistory();
  const [showMenu, setShowMenu] = useState(false);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useClickOutside(ref, () => setShowMenu(false));

  const Logout = () => {
    logout();
    history.push("/login");
  };

  return (
    <div className="w-full shadow-md top-0 left-0 right-0 bottom-0 fixed h-24 z-20 bg-sbg-white">
      <div
        className={`w-full shadow-md top-0 left-0 right-0 bottom-0 h-24 z-20 bg-sbg-white ${
          open && "-mb-nav-open"
        }`}
      >
        <nav className="items-center py-6 justify-between global-container flex  medium:hidden mobiles:justify-between mobiles:flex">
          <Link to="/dashboard" className="flex items-center">
            <img
              src={require("../../assets/gift-logo-sd.svg").default}
              className="w-8 h-10 -mt-2"
              alt="logo"
            />
            <h1 className="ml-2 font-bold text-2xl">Sabigift</h1>
          </Link>

          <div className="flex medium:hidden justify-between w-1/3">
            {dashMidLinks.map(({ name, link }) => {
              return (
                <Link className="mr-5" to={link}>
                  {name}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center medium:hidden">
            <Link
              to="/create-event"
              className=" py-2.5 px-11 bg-sbg-light-green text-transparent ml-3 rounded-lg text-base text-white mr-6 "
            >
              New Event
            </Link>

            <div className="mr-6">
              {/* <h4>Jimi & Joanna's Registry</h4> */}

              {/* <div className="flex justify-between items-center flex-col">

            </div> */}
            </div>

            <div className="relative">
              <img
                src={require("../../assets/caret.svg").default}
                alt="caret"
                className="ml-1 relative cursor-pointer"
                onClick={() => setShowMenu(!showMenu)}
              />

              {showMenu && (
                <div
                  className="absolute bg-white shadow-lg px-4 py-5 w-36 h-24  rounded-lg top-3 bottom-0 -left-30 right-0 flex flex-col items-center justify-center"
                  ref={ref}
                >
                  <Link className="flex mt-1 items-center w-full justify-center">
                    <img
                      src={require("../../assets/settings.svg").default}
                      alt="settings"
                      className="mr-1 h5"
                    />
                    <p className="text-lg text-sbg-grey">Settings</p>
                  </Link>

                  <p
                    className="text-sbg-grey text-lg text-center mt-2 cursor-pointer z-10"
                    onClick={() => Logout()}
                  >
                    Logout
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* ====== */}
          <div className="mobiles:block hidden">
            {!open ? (
              <HiMenu
                style={{ fontSize: 26 }}
                onClick={() => {
                  setOpen(true);
                }}
              />
            ) : (
              <RiCloseFill
                style={{ fontSize: 26 }}
                onClick={() => {
                  setOpen(false);
                }}
              />
            )}
          </div>
          {/* ===== */}
        </nav>
        <div className={` mobile-nav-li my-4 ${open ? "block" : "hidden"}`}>
          {dashMidLinks.map(({ name, link }) => {
            return (
              <li className="py-3 px-6">
                <Link
                  onClick={() => {
                    setOpen(false);
                  }}
                  to={link}
                >
                  {name}
                </Link>
              </li>
            );
          })}

          {dashEndLinks.map(({ name, link }) => {
            return (
              <li className="py-3 px-6">
                <Link
                  to={link}
                  onClick={() => {
                    if (name === "Logout") {
                      Logout();
                    }
                    setOpen(false);
                  }}
                >
                  {name}
                </Link>
              </li>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardNavbar;
